import Point from "./point";

export const LANDMARK_COLOR = "green";
export const EVACUATION_PLACE_COLOR = "rgb(255, 106, 26)";

export enum LandmarkType {
  Evacuation = "Evacuation",
  Maintenance = "Maintenance",
}

interface Landmark {
  id: string;
  room: string;
  name: string;
  type: LandmarkType;
  landmarkPoint: Point;
}

export interface LandmarkApi {
  id: string;
  room: string;
  name: string;
  type: LandmarkType;
  point: number[];
}

export const copyLandmark = (place: Landmark) => {
  return {
    ...place,
    landmarkPoint: { ...place.landmarkPoint },
  } as Landmark;
};

export const mapLandmarkApiToLandmark = (apiData: LandmarkApi) =>
  ({
    ...apiData,
    landmarkPoint: {
      coordinateX: apiData.point[0],
      coordinateY: apiData.point[1],
      coordinateTheta: apiData.point[2],
    } as Point,
  } as Landmark);

export const mapLandmarkToApi = (landmark: Landmark) =>
  ({
    ...landmark,
    point: [
      landmark.landmarkPoint.coordinateX,
      landmark.landmarkPoint.coordinateY,
      landmark.landmarkPoint.coordinateTheta ?? 0,
    ],
  } as LandmarkApi);

export const mapPartialLandmarkToApi = (landmark: Partial<Landmark>) =>
  ({
    ...landmark,
    point:
      landmark.landmarkPoint != null
        ? [
            landmark.landmarkPoint.coordinateX,
            landmark.landmarkPoint.coordinateY,
            landmark.landmarkPoint.coordinateTheta ?? 0,
          ]
        : undefined,
  } as LandmarkApi);

export default Landmark;
